/**
 * Festival Configuration
 *
 * @deprecated This file is maintained for backwards compatibility.
 * New code should import directly from '@/config/season' instead.
 *
 * @example
 * // Old (deprecated):
 * import { FESTIVAL_CONFIG } from '@/config/festival';
 *
 * // New (preferred):
 * import { SEASON_CONFIG, getSeasonYear, getFullSessionDateRange } from '@/config/season';
 */

import { SEASON_CONFIG } from './season';

/**
 * @deprecated Use SEASON_CONFIG.festival from '@/config/season' instead
 */
export const FESTIVAL_CONFIG = {
  season: SEASON_CONFIG.festival.season,
  tuition: SEASON_CONFIG.festival.tuition
} as const;
